import { WorkshopProductList } from '@products/models/workshop.model';

import { createActionGroup, emptyProps } from '@ngrx/store';

export const WorkshopActions = createActionGroup({
  source: 'Workshop Product',
  events: {
    'Set initial workshop product list': (workshopProductList: WorkshopProductList) => ({ workshopProductList }),
    'Reset reducer': emptyProps()
  }
});
